import { render, staticRenderFns } from "./GroupSearch.vue?vue&type=template&id=16bd50d8&"
import script from "./GroupSearch.vue?vue&type=script&lang=js&"
export * from "./GroupSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports